/**
 * <sb-nav> — the floating nav bar. Toggles a "solid" background once the
 * page has scrolled past the hero (or always, on non-home templates), and
 * opens/closes the mobile menu <dialog>.
 */
(function () {
  class SBNav extends HTMLElement {
    connectedCallback() {
      this.menuButton = this.querySelector('[data-sb-menu-open]');
      this.dialog = document.getElementById(this.getAttribute('data-menu-id'));
      this.forceSolid = this.hasAttribute('data-force-solid');

      this._onScroll = this._onScroll.bind(this);
      this._onScroll();
      window.addEventListener('scroll', this._onScroll, { passive: true });

      if (this.menuButton && this.dialog) {
        this.menuButton.addEventListener('click', () => this._openDrawer());
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this._closeDrawer();
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this._closeDrawer();
        });
        this.dialog.querySelectorAll('[data-sb-menu-close]').forEach((button) => {
          button.addEventListener('click', () => this._closeDrawer());
        });
      }
    }

    _openDrawer() {
      this.dialog.showModal();
      // Double rAF so the initial translate-x-full state paints before the
      // open class is added, otherwise the browser coalesces both into one
      // frame and the slide-in never animates.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.dialog.classList.add('sb-menu-open'));
      });
    }

    _closeDrawer() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.dialog.classList.remove('sb-menu-open');
      if (reduceMotion) {
        this.dialog.close();
        return;
      }
      const onTransitionEnd = (event) => {
        if (event.target !== this.dialog || event.propertyName !== 'translate') return;
        this.dialog.removeEventListener('transitionend', onTransitionEnd);
        this.dialog.close();
      };
      this.dialog.addEventListener('transitionend', onTransitionEnd);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
    }

    _onScroll() {
      const solid = this.forceSolid || window.scrollY > 20;
      this.classList.toggle('is-solid', solid);
    }
  }

  customElements.define('sb-nav', SBNav);
})();
